import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import App from "./App.vue";
import vSelect from "vue-select";
import VueRouter from "vue-router";
import VueTheMask from "vue-the-mask";
import VSwitch from "v-switch-case";
import Toast from "vue-toastification";
import "vue-select/dist/vue-select.css";
import TinyMce from "vue-tinymce-editor";
import "vue-toastification/dist/index.css";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import routes from "./services/Router/routes";
import Loading from "./services/Loading/Loading";
import DataTable from "./services/DataTable/Index";
import CustomEvents from "./services/Events/CustomEvents";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

import VuejsDialog from "vuejs-dialog";
import VuejsDialogMixin from "vuejs-dialog/dist/vuejs-dialog-mixin.min.js"; // only needed in custom components

// include the default style
import "vuejs-dialog/dist/vuejs-dialog.min.css";

Vue.config.productionTip = false;

const token = localStorage.getItem("agc-token");
const userData = JSON.parse(localStorage.getItem("user"));

Vue.use(VueSweetalert2, {
  confirmButtonColor: "#0d85c0",
  cancelButtonColor: "#c12433",
  confirmButtonText: "تایید",
});

Vue.use(VuejsDialog, {
  okText: "بله",
  cancelText: "خیر",
  animation: "bounce",
});

Vue.use({
  install() {
    const axiosBaseData = {
      baseURL: "https://cardapi.sabinarya.com/api/v1/",
    };
    if (token && token != null && typeof token != "undefined")
      axiosBaseData["headers"] = {
        token: localStorage.getItem("agc-token"),
      };
    const api = axios.create(axiosBaseData);
    api.interceptors.response.use(
      (response) => {
        let html = "";
        if (
          !response.config.SuppressedError &&
          !response.data.status &&
          response.data.errors &&
          response.data.showError === true
        ) {
          response.data.errors.map((error) => {
            html += error.message + "<br>";
          });
          Vue.swal.fire({
            title: "خطا",
            icon: "error",
            html,
            confirmButtonText: "متوجه شدم",
          });
        }
        if (response.data.responseCode == 401) {
          localStorage.removeItem("agc-token");
          window.location.href = "/login";
        }
        return response;
      },
      (error) => {
        throw error;
      },
    );
    Vue.prototype.$api = api;
    Vue.prototype.$customEvent = CustomEvents;
  },
});

Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    pageTitle: "",
    userData,
    role:
      userData && userData.roleTitle
        ? userData.roleTitle.toString().toLowerCase()
        : "",
    nationalReligious: [],
    organization: [],
    birthdates: [],
    adminToken: "40568",
    adminTokenExpireTime: "",
  },
});

Vue.use(VueRouter);
const router = new VueRouter({
  routes,
  base: "/",
  mode: "history",
  linkExactActiveClass: "active",
});

router.afterEach((to) => {
  if (to.name == "login" && localStorage.getItem("agc-token") != null)
    return router.push({ name: "index" });
  else if (
    to.name != "resetPassword" &&
    to.name != "login" &&
    localStorage.getItem("agc-token") == null
  )
    return router.push({ name: "login" });
  Vue.nextTick(() => {
    document.title = to.meta.title
      ? "آریا گیفت کارت | " + to.meta.title
      : "آریا گیفت کارت";
    store.state.pageTitle = to.meta.title;
    $(".nav-sub-item").removeClass("active");
    $(".nav-item")
      .removeClass("active")
      .removeClass("show");
    $(".nav-item").each(function(index, item) {
      $(item)
        .find("a")
        .each(function(linkIndex, linkItem) {
          let getCurrentRoute = window.location.pathname.split("/");
          getCurrentRoute.splice(0, 1);
          let currentRoute = getCurrentRoute.join("/");
          if ("/" + currentRoute === $(linkItem).attr("href")) {
            $(linkItem)
              .closest(".nav-sub-item")
              .addClass("active");
            $(linkItem)
              .closest(".nav-item")
              .addClass("active")
              .addClass("show");
          }
        });
    });
  });
});

Vue.use(Toast);
Vue.use(VueTheMask);
Vue.component("Loading", Loading);
Vue.component("DataTable", DataTable);
Vue.component("Tinymce", TinyMce);
Vue.component("Vselect", vSelect);
Vue.component("Datepicker", VuePersianDatetimePicker);
Vue.use(VSwitch);

Vue.mixin({
  methods: {
    async generateCaptcha() {
      let result = await this.$api.get("Captcha/Generate");
      if (result.data.status)
        return "data:image/png;base64," + result.data.result.base64Captcha;
      return false;
    },
  },
});

new Vue({
  render: (h) => h(App),
  router,
  store,
}).$mount("#app");
